// Settings service (editable site config, e.g. contact info)
import { apiRequest } from "./api";

export const settingsService = {
  getContact: async () => {
    return await apiRequest("/settings/contact", {
      method: "GET",
      requiresAuth: false,
    });
  },

  updateContact: async (contact) => {
    return await apiRequest("/settings/contact", {
      method: "PUT",
      requiresAuth: true,
      body: JSON.stringify(contact),
    });
  },

  getDonationEnabled: async () => {
    const data = await apiRequest("/settings/donation", {
      method: "GET",
      requiresAuth: false,
    });
    // Default to enabled if the field is missing (e.g. key not yet in DB).
    return data.enabled !== false;
  },

  updateDonationEnabled: async (enabled) => {
    return await apiRequest("/settings/donation", {
      method: "PUT",
      requiresAuth: true,
      body: JSON.stringify({ enabled }),
    });
  },
};
